// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media (min-width:769px){.job-application-content__left{flex:40 40 200px}.job-application-content__right{flex:60 60 400px}}", ""]);
// Exports
module.exports = exports;
